import createClient from "../../helpers/api-client";
import GoogleMapsApi from "../../helpers/google-maps-api.js";
import { generateFullRegionName } from "../../helpers/region-suffix.js";

const googleMaps = new GoogleMapsApi();

const storeSuffix = "Filters";

// Actions
export const FETCH_FILTERS = `fetchRegionsFiltersAction${storeSuffix}`;
export const FETCH_CLOSEST_REGION = `fetchClosestRegionAction${storeSuffix}`;

// Mutations
export const BEGIN_FETCH_FILTERS = `beginFetchFiltersMutation${storeSuffix}`;
export const BEGIN_FETCH_CLOSEST_REGION = `beginFetchClosestRegionMutation${storeSuffix}`;
export const RECEIVED_FILTERS = `receivedFiltersMutation${storeSuffix}`;
export const RECEIVED_CLOSEST_REGION = `receivedClosestRegionMutation${storeSuffix}`;
export const FILTERS_NOT_FOUND = `filtersNotFoundMutation${storeSuffix}`;
export const CLOSEST_REGION_NOT_FOUND = `closestRegionNotFoundMutation${storeSuffix}`;

// Getters
export const GET_CATEGORIES = `getCategoriesFiltersGetter${storeSuffix}`;
export const GET_REGIONS = `getRegionsFiltersGetter${storeSuffix}`;
export const GET_CERTIFICATES = `getCertificatesFiltersGetter${storeSuffix}`;
export const GET_CLOSEST_REGION = `getClosestRegionGetter${storeSuffix}`;
export const GET_CATEGORY_BY_NAME = `getCategoryByNameGetter${storeSuffix}`;
export const GET_REGION_BY_NAME = `getRegionByNameGetter${storeSuffix}`;

export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;
export const GET_REGION_BY_ID = `getRegionByIdGetter${storeSuffix}`;

export const modelState = () => ({
    filters: {
        isLoading: true,
        error: false,
        data: {
            categories: {},
            regions: [],
            certificates: [],
            closestRegion: null
        }
    }
});

export const actions = {
    [FETCH_FILTERS]: ({ state, commit }) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            if (
                typeof state.filters.data.categories === "undefined" ||
                typeof state.filters.data.regions === "undefined"
            ) {
                resolve(state.filters);
            }

            commit(BEGIN_FETCH_FILTERS);

            try {
                const res = await apiClient.get(`/api/filters`);
                commit(RECEIVED_FILTERS, res);
                resolve(res);
            } catch (error) {
                commit(FILTERS_NOT_FOUND, {
                    error
                });
                reject(error);
            }
        });
    },
    [FETCH_CLOSEST_REGION]: ({ state, commit, dispatch }, coordinates) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            if (state.filters.data.closestRegion) {
                resolve(state.filters.data.closestRegion);
            }

            if (typeof state.filters.data.regions === "undefined") {
                await dispatch(FETCH_FILTERS);
            }

            try {
                googleMaps.load().then(() => {
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode(
                        { location: coordinates },
                        (results, status) => {
                            if (status === "OK") {
                                results.forEach(function(result) {
                                    result.types.forEach(function(type) {
                                        if (
                                            type === "locality" ||
                                            type ===
                                                "administrative_area_level_2"
                                        ) {
                                            const municipalityName =
                                                result.address_components[0]
                                                    .long_name;
                                            state.filters.data.regions.forEach(
                                                (region, i) => {
                                                    region.Subcategories.forEach(
                                                        (subregion, i) => {
                                                            const municipalityNameLowerCase = municipalityName.toLowerCase();
                                                            const subregionLowerCase = subregion.Name.toLowerCase();
                                                            var regionWithMunicipalSuffix = generateFullRegionName(
                                                                subregionLowerCase
                                                            );

                                                            if (
                                                                subregionLowerCase ===
                                                                    municipalityNameLowerCase ||
                                                                regionWithMunicipalSuffix ===
                                                                    municipalityNameLowerCase
                                                            ) {
                                                                commit(
                                                                    RECEIVED_CLOSEST_REGION,
                                                                    subregion
                                                                );
                                                                resolve(
                                                                    subregion
                                                                );
                                                            }
                                                        }
                                                    );
                                                }
                                            );
                                        }
                                    });
                                });
                            } else {
                                throw "Geocoder failed due to: " + status;
                            }
                        }
                    );
                });
            } catch (error) {
                commit(CLOSEST_REGION_NOT_FOUND, {
                    error
                });
                reject(error);
            }
        });
    }
};

export const mutations = {
    [BEGIN_FETCH_FILTERS]: state => {
        state.filters.isLoading = true;
        state.filters.error = false;
    },
    [BEGIN_FETCH_CLOSEST_REGION]: state => {
        // state.filters.isLoading = true;
        // state.filters.error = false;
    },
    [RECEIVED_FILTERS]: (state, payload) => {
        const { data } = payload;
        state.filters.isLoading = false;
        state.filters.error = false;
        state.filters.data.regions = data.regions;
        state.filters.data.categories = data.categories;
        state.filters.data.certificates = data.certificates;
    },
    [RECEIVED_CLOSEST_REGION]: (state, region) => {
        // state.filters.isLoading = false;
        // state.filters.error = false;
        state.filters.data.closestRegion = region;
    },
    [FILTERS_NOT_FOUND]: (state, payload) => {
        state.filters.isLoading = false;
        state.filters.error = true;
    },
    [CLOSEST_REGION_NOT_FOUND]: (state, payload) => {
        // state.filters.isLoading = false;
        // state.filters.error = true;
    }
};

export const getters = {
    [GET_CATEGORIES]: state => {
        let categories = state.filters.data.categories;

        Object.keys(categories).forEach(key => {
            categories[key].Subcategories.sort((a, b) => {
                return a.Name.trim().localeCompare(b.Name.trim());
            });
        });

        return categories;
    },
    [GET_REGIONS]: state => {
        return state.filters.data.regions.slice(1);
    },
    [GET_CATEGORY_BY_NAME]: state => categoryName => {
        categoryName = categoryName.toLowerCase();
        let category;

        // Loop differs from GET_REGION_BY_NAME because state.filters.data.categories is object
        for (let key in state.filters.data.categories) {
            if (!state.filters.data.categories.hasOwnProperty(key)) continue;

            const { Subcategories = [] } = state.filters.data.categories[key];

            category = Subcategories.find(item => {
                if (!item.URLName) {
                    return false;
                }

                return item.URLName.toLowerCase() == categoryName;
            });

            if (category) break;
        }

        return category;
    },
    [GET_REGION_BY_NAME]: state => regionName => {
        let region;

        state.filters.data.regions.slice(1).some(item => {
            const res = item.Subcategories.find(
                sub => sub.URLName === regionName.toLowerCase()
            );

            if (res) {
                region = res;
                return true; // breaks on success
            }
        });
        return region;
    },
    [GET_REGION_BY_ID]: state => id => {
        let region;

        state.filters.data.regions.slice(1).some(item => {
            const res = item.Subcategories.find(sub => sub.Id === id);

            if (res) {
                region = res;
                return true; // breaks on success
            }
        });
        return region ? region.Name : "";
    },
    [GET_CERTIFICATES]: state => {
        return state.filters.data.certificates;
    },
    [GET_CLOSEST_REGION]: state => {
        return state.filters.data.closestRegion;
    },
    [IS_LOADING]: state => {
        return state.filters.isLoading;
    },
    [GET_ERROR]: state => {
        return state.filters.error;
    }
};



// WEBPACK FOOTER //
// ./src/store/store-models/filters-model.js